import { render, staticRenderFns } from "./BusinessClient.vue?vue&type=template&id=7b76cb4c&"
import script from "./BusinessClient.vue?vue&type=script&lang=ts&"
export * from "./BusinessClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports